<template>
	<div class="summary-period-select">
		<div class="input-wrap">
			<div class="input-title">集計期間</div>
			<div class="sv-field">
				<b-select v-model="periodId" @input="onPeriodChange">
					<option
						v-for="(row, index) in periods"
						:value="index"
						:key="index">
						{{ row }}
					</option>
				</b-select>

				<div v-show="periodId === 1">
					<div class="horizontal-center mt-10">
						<date-select :dateProvided="dateProvided" :years="years" :isDateShow="false" @change="onStartChange"></date-select>
						<div class="ml-10">から</div>
					</div>
					<div class="horizontal-center mt-10">
						<date-select :dateProvided="dateProvided" :years="years" :isDateShow="false" @change="onEndChange"></date-select>
						<div class="ml-10">まで</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import DateSelect from '@/components/DateSelect'
import moment from 'moment'

export default {
	name: 'SummaryPeriodSelect',
	components: {
		DateSelect,
	},
	props: {
		dateProvided: {
			type: String,
			default: ''
		},
	},
	data() {
		return {
			periodId: 0,
			periods: ['過去1ヵ月', '期間指定', 'すべて'],
			years: [],
		}
	},
	created() {
		for (let i = moment().year(); i >= 2019; i--) {
			this.years.push(i);
		}
	},
	mounted() {
	},
	computed: {
	},
	methods: {
		onPeriodChange: function() {
			this.$emit('period-change', this.periodId);
		},
		onStartChange: function(date) {
			this.$emit('start-change', date);
		},
		onEndChange: function(date) {
			this.$emit('end-change', date);
		},
	},
}
</script>

<style lang="scss">

</style>
